var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3034_460765)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33464 3.96094C2.75934 3.96094 2.29297 4.42731 2.29297 5.0026V7.36674C3.48743 7.6489 4.3763 8.72195 4.3763 10.0026C4.3763 11.2833 3.48743 12.3563 2.29297 12.6385V15.0026C2.29297 15.5779 2.75933 16.0443 3.33464 16.0443H16.668C17.2428 16.0443 17.7096 15.5774 17.7096 15.0017V5.00402C17.7096 4.42803 17.2426 3.96094 16.668 3.96094H3.33464ZM1.04297 5.0026C1.04297 3.73695 2.06898 2.71094 3.33464 2.71094H16.668C17.9343 2.71094 18.9596 3.73907 18.9596 5.00402V15.0017C18.9596 16.2668 17.9341 17.2943 16.668 17.2943H3.33464C2.06899 17.2943 1.04297 16.2683 1.04297 15.0026V12.0859C1.04297 11.7408 1.32279 11.4609 1.66797 11.4609C2.47338 11.4609 3.1263 10.808 3.1263 10.0026C3.1263 9.1972 2.47338 8.54427 1.66797 8.54427C1.32279 8.54427 1.04297 8.26445 1.04297 7.91927V5.0026ZM11.8763 10.0026C11.8763 9.65743 12.1561 9.3776 12.5013 9.3776H15.0013C15.3465 9.3776 15.6263 9.65743 15.6263 10.0026C15.6263 10.3478 15.3465 10.6276 15.0013 10.6276H12.5013C12.1561 10.6276 11.8763 10.3478 11.8763 10.0026ZM9.16797 12.7109C8.82279 12.7109 8.54297 12.9908 8.54297 13.3359C8.54297 13.6811 8.82279 13.9609 9.16797 13.9609H15.0013C15.3465 13.9609 15.6263 13.6811 15.6263 13.3359C15.6263 12.9908 15.3465 12.7109 15.0013 12.7109H9.16797Z",
    fill: "#76B72A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3034_460765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupport);
export default __webpack_public_path__ + "static/media/ic-support.71b626edf77478c22fec9d95a15b5f0f.svg";
export { ForwardRef as ReactComponent };